import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KrulesService {
  _host: string = '';
  _apiPath: string = '/api/v2';
  _basePath: string = `${this._host}${this._apiPath}`;
  constructor(private http: HttpClient) {}

  /**
   * Fetch the list of subscription IDs visible to the caller. The backend
   * encapsulates all multitenant-mode + admin logic; the frontend treats
   * the response uniformly across modes.
   * See backend_api_v2/auth.py: create_subscription_lister.
   */
  getSubscriptions(token: string): Promise<string[]> {
    return lastValueFrom(
      this.http.get<string[]>(`${this._host}/api/v2/subscriptions/`, {
        headers: { Authorization: `Bearer ${token}` },
      }),
    );
  }

  deleteGroup(token: string, subscriptionId: string, groupId: string) {
    const url = `${this._basePath}/${subscriptionId}/${groupId}`;
    return this.http.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  deleteEntity(
    token: string,
    subscriptionId: string,
    groupId: string,
    entityId: string
  ) {
    const url = `${this._basePath}/${subscriptionId}/${groupId}/${entityId}`;
    return this.http.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
